import { CartAddEvent } from '@theme/events';
import { fetchConfig } from '@theme/utilities';

const FORM_SELECTOR = '.java-cart-upsell__form';
const LIST_SELECTOR = '[data-java-upsell-list]';

function getCartSectionIds() {
  return [...document.querySelectorAll('cart-items-component[data-section-id]')]
    .map((element) => element.dataset.sectionId)
    .filter(Boolean)
    .filter((id, index, list) => list.indexOf(id) === index);
}

function updateVariantPrice(select) {
  const card = select.closest('.java-cart-upsell-card');
  const price = card?.querySelector('[data-java-upsell-price]');
  const option = select.selectedOptions?.[0];
  if (!price || !option) return;
  const current = option.dataset.price || '';
  const compareAt = option.dataset.compareAt || '';
  price.innerHTML = `<strong>${current}</strong>${compareAt ? `<s>${compareAt}</s>` : ''}`;
}

function showCandidate(list, index) {
  const candidates = [...list.querySelectorAll('[data-java-upsell-candidate]')];
  if (!candidates.length) return;
  const normalized = ((index % candidates.length) + candidates.length) % candidates.length;
  candidates.forEach((candidate, candidateIndex) => {
    candidate.hidden = candidateIndex !== normalized;
  });
  list.dataset.javaUpsellIndex = String(normalized);
}

function initializeList(list) {
  if (!(list instanceof HTMLElement)) return;
  const candidates = [...list.querySelectorAll('[data-java-upsell-candidate]')];
  if (!candidates.length) return;

  if (!list.dataset.javaUpsellInitialized) {
    const randomIndex = Math.floor(Math.random() * candidates.length);
    showCandidate(list, randomIndex);
    list.dataset.javaUpsellInitialized = 'true';
  }
}

function initializeUpsells(root = document) {
  root.querySelectorAll?.(LIST_SELECTOR).forEach(initializeList);
}

async function addUpsell(form) {
  const button = form.querySelector('[data-java-upsell-submit]');
  const status = form.querySelector('[data-java-upsell-status]');
  const originalHTML = button?.innerHTML || 'Sí, agrégalo';

  if (button) {
    button.disabled = true;
    button.textContent = 'Añadiendo…';
  }
  if (status) status.textContent = '';

  try {
    const formData = new FormData(form);
    const sectionIds = getCartSectionIds();
    if (sectionIds.length) {
      formData.set('sections', sectionIds.join(','));
      formData.set('sections_url', window.location.pathname);
    }

    const config = fetchConfig('javascript', { body: formData });
    const response = await fetch(Theme.routes.cart_add_url, {
      ...config,
      headers: { ...config.headers, Accept: 'application/json' },
    });
    const payload = await response.json();
    if (!response.ok || payload.status) throw new Error(payload.description || payload.message || 'No se pudo añadir el producto.');

    form.dispatchEvent(new CartAddEvent(payload, 'java-cart-upsell', {
      source: 'java-cart-upsell',
      itemCount: Number(formData.get('quantity')) || 1,
      variantId: String(formData.get('id') || ''),
      sections: payload.sections,
    }));
    if (status) status.textContent = 'Añadido';
  } catch (error) {
    console.error(error);
    if (status) status.textContent = error instanceof Error ? error.message : 'No se pudo añadir.';
  } finally {
    if (button?.isConnected) {
      button.disabled = false;
      button.innerHTML = originalHTML;
    }
  }
}

document.addEventListener('change', (event) => {
  const select = event.target.closest?.('[data-java-upsell-variant]');
  if (select instanceof HTMLSelectElement) updateVariantPrice(select);
});

document.addEventListener('click', (event) => {
  const nextButton = event.target.closest?.('[data-java-upsell-next]');
  if (!nextButton) return;
  const section = nextButton.closest('.java-cart-upsell');
  const list = section?.querySelector(LIST_SELECTOR);
  if (!(list instanceof HTMLElement)) return;
  const candidates = [...list.querySelectorAll('[data-java-upsell-candidate]')];
  if (candidates.length < 2) return;
  const current = Number(list.dataset.javaUpsellIndex || 0);
  showCandidate(list, current + 1);
});

document.addEventListener('submit', (event) => {
  const form = event.target.closest?.(FORM_SELECTOR);
  if (!(form instanceof HTMLFormElement)) return;
  event.preventDefault();
  addUpsell(form);
});

document.addEventListener('cart:update', () => {
  window.setTimeout(() => initializeUpsells(), 60);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeUpsells(), { once: true });
} else {
  initializeUpsells();
}
